import {EndoMultiToothExamToothDataModel} from './endo-multi-tooth-exam-tooth-data.model';
import {XauditModel} from '../../../xaudit.model';

export class EndoMultiToothExamTeethInExamDataModel extends XauditModel {
  MTETiithInExanID: string;
  MTEID: string;
  MTEToothID: string;
  ToothOrder: number;

  // Nav properties
  dataEndoMutiToothExamTooth: EndoMultiToothExamToothDataModel;

  // UI ONLY
  isLocked = false;
}
